import dayjs from 'dayjs'

export function formatDate(date: number) {
  return dayjs('2019-01-25').format('DD/MM/YYYY')
}
